import axios from "axios";
import { uploadImage } from "services/firebase";
import {
  BASE_URL,
  API_KEY,
  LOGIN,
  GET_USERS,
  GET_USER_DETAIL,
  GET_PROJECTS,
  GET_REPORTS,
  GET_PROJECT_DETAIL,
  ADD_PROJECT,
  ADD_ACCOUNT,
  SEND_FORGOT_OTP,
  VERIFY_OTP,
  CHANGE_FORGOT_PASSWORD,
  CHANGE_PASSWORD,
  UPDATE_USER_STATUS,
  UPDATE_USER_DETAIL,
  EDIT_PROJECT_DETAIL,
  GET_INSPECTORS_LIST,
  PROJECT_STATUS,
  MARK_AS_COMPLETE,
  SEARCH_INSPECTOR_LIST,
  GET_INSPECTIONS,
  GET_INSPECTION_DETAIL,
  INSPECTION_STATUS,
  REOPEN_PROJECT,
  GET_INSPECTION_BYPROJECT,
  ADD_DICCIPLINE,
  GET_DISCIPLINEDATA,
  ADD_INSPECTIONTYPE,
  ADD_COMMENT,
  CHANGE_INPECTION_STATUS,
  UPDATE_INSPECTION,
  EDIT_DISCIPLINE,
  EDIT_INSPECTIONTYPE,
  EDIT_COMMENT,
  DELETE_COMMENT,
  DELETE_INSPECTIONTYPE,
  DELTED_DISCIPLINE,
  COMPLETE_INSPECTION,
  GETPROJECT_BY_MANAGER,
  GET_INSPECTOR_INSPECTIONS,
  ADD_INSPECTION,
  ADD_DEFICIENCYLOG,
  GET_DEFICIENCYLOG_LIST,
  EDIT_DEFICIENCYLOG,
  GET_DEFICIENCYLOG_DETAILS,
  DELETE_DEFICIENCYLOG,
  LOGS_EXIST,
  GET_ALL_DEFICIENCY_LOG,
  GET_ALLUSERS_LIST,
  RESTORE_INSPECTION,
} from "./apiConstants";
import { toast } from "react-toastify";

const axiosInstance = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
  headers: {
    apiKey: API_KEY,
  },
});

const axiosInstanceAfterLogin = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
  headers: {
    apiKey: API_KEY,
    authorization: localStorage.getItem("loginData")
      ? JSON.parse(localStorage.getItem("loginData")).token
      : "",
  },
});

const axiosInstanceAfterLogin5 = (manualToken = "") => {
  return axios.create({
    baseURL: BASE_URL,
    timeout: 30000,
    headers: {
      apiKey: API_KEY,
      authorization: manualToken
        ? manualToken
        : localStorage.getItem("loginData")
        ? JSON.parse(localStorage.getItem("loginData")).token
        : "",
    },
  });
};

// Retry logic
axiosInstanceAfterLogin.interceptors.response.use(
  (response) => response,
  async (error) => {
    const { config, response } = error;
    const maxRetries = 3;

    if (response && response.status >= 500 && config.retryCount < maxRetries) {
      config.retryCount = config.retryCount ? config.retryCount + 1 : 1;
      const delay = Math.pow(2, config.retryCount) * 1000; // Exponential backoff
      await new Promise((resolve) => setTimeout(resolve, delay));
      return axiosInstanceAfterLogin(config); // Retry the request
    }

    toast.error("Failed to fetch data. Please try again later.");
    return Promise.reject(error);
  }
);

const handleApiError = (error) => {
  if (error.response) {
    // Server-side error
    toast.error(`Server Error: ${error.response.statusText}`);
  } else if (error.request) {
    // Network error
    toast.error("Network Error: Please check your internet connection.");
  } else {
    // Client-side error
    toast.error(`Error: ${error.message}`);
  }
};

const api = {
  login: async (userData) => {
    try {
      const response = await axiosInstance.post(LOGIN, userData);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);
      console.error("Error logging in:", error);
      throw error;
    }
  },
  sendForgotOtp: async (data) => {
    try {
      const response = await axiosInstance.post(SEND_FORGOT_OTP, data);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);
      console.error("Error sending forgot OTP:", error);
      throw error;
    }
  },
  verifyOtp: async (data) => {
    try {
      const response = await axiosInstance.post(VERIFY_OTP, data);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);
      console.error("Error verifying OTP:", error);
      throw error;
    }
  },
  changeForgotPassword: async (data) => {
    try {
      const response = await axiosInstance.post(CHANGE_FORGOT_PASSWORD, data);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);
      console.error("Error changing forgot password:", error);
      throw error;
    }
  },
  getUsersList: async (filterData) => {
    try {
      const response = await axiosInstanceAfterLogin.post(
        GET_USERS,
        filterData
      );
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);
      console.error("Error fetching users:", error);
      handleApiError(error);
      throw error;
    }
  },
  getUserDetail: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(
        GET_USER_DETAIL,
        data
      );
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);
      console.error("Error fetching users:", error);
      throw error;
    }
  },

  getProjectsList: async (filterData) => {
    try {
      const response = await axiosInstanceAfterLogin.post(
        GET_PROJECTS,
        filterData
      );
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);
      console.error("Error fetching projects:", error);
      throw error; // Rethrow error to handle in components
    }
  },

  getProjectsbyManager: async (filterData) => {
    try {
      const response = await axiosInstanceAfterLogin.post(
        GETPROJECT_BY_MANAGER,
        filterData
      );
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);
      console.error("Error fetching Project by mannager:", error);
      throw error; // Rethrow error to handle in components
    }
  },

  getReportsList: async (filterData) => {
    try {
      const response = await axiosInstanceAfterLogin.post(
        GET_REPORTS,
        filterData
      );
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);
      console.error("Error fetching reports:", error);
      throw error;
    }
  },

  getProjectDetail: async (filterData) => {
    try {
      const response = await axiosInstanceAfterLogin.post(
        GET_PROJECT_DETAIL,
        filterData
      );
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);
      console.error("Error fetching users:", error);
      throw error;
    }
  },

  getInspectionDetails: async (filterData, token = "") => {

    const axiosInstance1 = axiosInstanceAfterLogin5(token);

    try {
      const response = await axiosInstance1.post(
        GET_INSPECTION_DETAIL,
        filterData
      );
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);
      console.error("Error fetching users:", error);
      throw error;
    }
  },

  addProject: async (projectData) => {
    try {
      let dataToSubmit = { ...projectData };

      // rolling back to stringify
      if (projectData.links) {
        dataToSubmit.links = JSON.stringify(projectData.links);
      }

      if (projectData.site_contacts) {
        dataToSubmit.site_contacts = JSON.stringify(projectData.site_contacts);
      }

      if (projectData.manager) {
        dataToSubmit.manager = JSON.stringify(projectData.manager);
      }

      const response = await axiosInstanceAfterLogin.post(
        ADD_PROJECT,
        dataToSubmit
      );
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);
      console.error("Error adding project:", error);
      throw error;
    }
  },

  addInspection: async (InspectionData) => {
    try {
      let dataToSubmit = { ...InspectionData };

      //Rolled back to json stringify sent inside layour add Inspection/index.js
      if (InspectionData.discipline_data) {
        dataToSubmit.discipline_data = InspectionData.discipline_data;
      }

      if (InspectionData.deficiencies_found) {
        dataToSubmit.deficiencies_found = InspectionData.deficiencies_found;
      }

      if (InspectionData.app_site_representative) {
        dataToSubmit.app_site_representative =
          InspectionData.app_site_representative;
      }

      const response = await axiosInstanceAfterLogin.post(
        ADD_INSPECTION,
        dataToSubmit
      );
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);
      console.error("Error adding Inspection:", error);
      throw error;
    }
  },

  addAccount: async (accountData) => {
    try {
      let dataToSubmit = { ...accountData };

      if (accountData.profile_picture) {
        const uploadImageUrl = await uploadImage(accountData.profile_picture);
        dataToSubmit.profile_picture = uploadImageUrl;
      }

      const response = await axiosInstanceAfterLogin.post(
        ADD_ACCOUNT,
        dataToSubmit
      );
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);
      console.error("Error adding account:", error);
      throw error;
    }
  },

  changePassword: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(
        CHANGE_PASSWORD,
        data
      );
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);
      console.error("Error changing password:", error);
      throw error;
    }
  },

  updateUserStatus: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(
        UPDATE_USER_STATUS,
        data
      );
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);
      console.error("Error updating user status:", error);
      throw error;
    }
  },

  updateUserDetail: async (data) => {
    try {
      let dataToSubmit = { ...data };
      
      if (data.profile_picture instanceof File) {
        const uploadImageUrl = await uploadImage(data.profile_picture);
        dataToSubmit.profile_picture = uploadImageUrl;
                }

      const response = await axiosInstanceAfterLogin.post(
        UPDATE_USER_DETAIL,
        dataToSubmit
      );

      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);
      console.error("Error updating user detail:", error);
      throw error;
    }
  },
  editProjectDetail: async (projectData) => {
    try {
      let dataToSubmit = { ...projectData };

      // send arrays/objects directly; backend accepts JSON bodies
      if (projectData.links) {
        dataToSubmit.links = JSON.stringify(projectData.links);
      }

      if (projectData.site_contacts) {
        dataToSubmit.site_contacts = JSON.stringify(projectData.site_contacts);
      }

      if (projectData.manager) {
        dataToSubmit.manager = JSON.stringify(projectData.manager);
      }

      const response = await axiosInstanceAfterLogin.post(
        EDIT_PROJECT_DETAIL,
        dataToSubmit
      );
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);
      console.error("Error editing project detail:", error);
      throw error;
    }
  },

  getInspectorsList: async (filterData) => {
    try {
      const response = await axiosInstanceAfterLogin.post(
        GET_INSPECTORS_LIST,
        filterData
      );
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);
      console.error("Error fetching inspectors:", error);
      throw error;
    }
  },

  projectStatus: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(PROJECT_STATUS, data);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);
      console.error("Error updating user status:", error);
      throw error;
    }
  },

  inspectionStatus: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(
        INSPECTION_STATUS,
        data
      );
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);
      console.error("Error updating user status:", error);
      throw error;
    }
  },

  changeInspectionStatus: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(
        CHANGE_INPECTION_STATUS,
        data
      );
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);
      console.error("Error in update the status of  Inspection status:", error);
      throw error;
    }
  },
  completeInspectionStatus: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(
        COMPLETE_INSPECTION,
        data
      );
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);
      console.error("Error in update the status of  Inspection status:", error);
      throw error;
    }
  },
  markAsComplete: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(
        MARK_AS_COMPLETE,
        data
      );
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);
      console.error("Error marking as complete:", error);
      throw error;
    }
  },

  reopenProject: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(REOPEN_PROJECT, data);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);
      console.error("Error in reopen project:", error);
      throw error;
    }
  },

  searchInspectorList: async (filterData) => {
    try {
      const response = await axiosInstanceAfterLogin.post(
        SEARCH_INSPECTOR_LIST,
        filterData
      );
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);
      console.error("Error searching inspectors:", error);
      throw error;
    }
  },

  getInspectionList: async (filterData) => {
    try {
      const response = await axiosInstanceAfterLogin.post(
        GET_INSPECTIONS,
        filterData
      );

      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);
      console.error("Error fetching Inspections:", error);
      throw error; // Rethrow error to handle in components
    }
  },

  getInspectorInspectionList: async (filterData) => {
    try {
      const response = await axiosInstanceAfterLogin.post(
        GET_INSPECTOR_INSPECTIONS,
        filterData
      );

      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText},  (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);
      console.error("Error fetching Inspections:", error);
      throw error;
    }
  },

  getInspectionListByProject: async (filterData) => {
    try {
      const response = await axiosInstanceAfterLogin.post(
        GET_INSPECTION_BYPROJECT,
        filterData
      );

      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);
      console.error("Error fetching project Inspections:", error);
      throw error; // Rethrow error to handle in components
    }
  },

  addDiscipline: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(ADD_DICCIPLINE, data);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);
      console.error("Error in add Discipline:", error);
      throw error;
    }
  },

  editDiscipline: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(
        EDIT_DISCIPLINE,
        data
      );
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);
      console.error("Error in Edit Discipline:", error);
      throw error;
    }
  },

  addInspectiontype: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(
        ADD_INSPECTIONTYPE,
        data
      );
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);
      console.error("Error in add Location:", error);
      throw error;
    }
  },

  editInspectiontype: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(
        EDIT_INSPECTIONTYPE,
        data
      );
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);
      console.error("Error in Edit Discipline Location:", error);
      throw error;
    }
  },

  addComment: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(ADD_COMMENT, data);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);
      console.error("Error in add Comment:", error);
      throw error;
    }
  },

  editComment: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(EDIT_COMMENT, data);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);
      console.error("Error in Edit Discipline Comment:", error);
      throw error;
    }
  },

  editInspection: async (InspectionData) => {
    try {
      let dataToSubmit = { ...InspectionData };

      // Send arrays/objects directly; backend accepts JSON bodies and will parse arrays.
      // Update  //Rolled back to json stringify sent inside layour add UpdateInspection/index.js
      if (InspectionData.discipline_data) {
        dataToSubmit.discipline_data = InspectionData.discipline_data;
      }

      if (InspectionData.deficiencies_found) {
        dataToSubmit.deficiencies_found = InspectionData.deficiencies_found;
      }

      if (InspectionData.app_site_representative) {
        dataToSubmit.app_site_representative =
          InspectionData.app_site_representative;
      }

      const response = await axiosInstanceAfterLogin.post(
        UPDATE_INSPECTION,
        dataToSubmit
      );
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);
      console.error("Error in updating the Inspection detail:", error);
      throw error;
    }
  },

  getDisciplineData: async () => {
    try {
      const response = await axiosInstanceAfterLogin.post(GET_DISCIPLINEDATA);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);
      console.error("Error in get Discipline data:", error);
      throw error;
    }
  },

  deleteInspectionType: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(
        DELETE_INSPECTIONTYPE,
        data
      );
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);
      console.error("Error in Delete Discipline Location:", error);
      throw error;
    }
  },

  deleteComment: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(DELETE_COMMENT, data);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);
      console.error("Error in Delete Discipline Comment:", error);
      throw error;
    }
  },

  deleteDiscipline: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(
        DELTED_DISCIPLINE,
        data
      );
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);
      console.error("Error in Delete Discipline:", error);
      throw error;
    }
  },

  // Deficiency log API Calling
  addDeficiencylog: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(
        ADD_DEFICIENCYLOG,
        data
      );
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);
      console.error("Error in add Deficieny log:", error);
      throw error;
    }
  },

  getDeficiecnylogList: async (filterData) => {
    try {
      const response = await axiosInstanceAfterLogin.post(
        GET_DEFICIENCYLOG_LIST,
        filterData
      );

      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);
      console.error("Error fetching deficiencly log list:", error);
      throw error; // Rethrow error to handle in components
    }
  },

  getAllDeficiecnylogList: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(
        GET_ALL_DEFICIENCY_LOG,
        data
      );

      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);
      console.error("Error fetching downlod deficiency log list:", error);
      throw error; // Rethrow error to handle in components
    }
  },

  deleteDeficiencylog: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(
        DELETE_DEFICIENCYLOG,
        data
      );
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);
      console.error("Error in Delete Deficiency log", error);
      throw error;
    }
  },

  getDeficiencylogDetails: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(
        GET_DEFICIENCYLOG_DETAILS,
        data
      );
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);
      console.error("Error in Fetcing details of Deficiency log", error);
      throw error;
    }
  },

  editDeifciencylog: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(
        EDIT_DEFICIENCYLOG,
        data
      );
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);
      console.error("Error in updating the Deficiency log:", error);
      throw error;
    }
  },

  logsExist: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(LOGS_EXIST, data);
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);
      console.error(
        "Error in checking the Deficiency log exist or not:",
        error
      );
      throw error;
    }
  },

  getInspectorList: async (filterData) => {
    try {
      const response = await axiosInstanceAfterLogin.post(
        GET_ALLUSERS_LIST,
        filterData
      );
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);
      console.error("Error fetching Users list:", error);
      throw error;
    }
  },

  restoreInspection: async (data) => {
    try {
      const response = await axiosInstanceAfterLogin.post(
        RESTORE_INSPECTION,
        data
      );
      if (response.status !== 200) {
        const errorMessage = `Error: ${response.statusText} (${response.status})`;
        throw new Error(errorMessage);
      }
      return response.data;
    } catch (error) {
      handleApiError(error);
      console.error("Error in Restore Inspection:", error);
      throw error;
    }
  },
};

export default api;
